export const ACTIONS = {
  ATTACK: 'attack',
  DEFEAT: 'defeat',
  CHARGER: 'charger',
  POWER: 'power',
};

export const GAMEMODES = {
  IA: 'IA',
  MULTIPLAYER: 'MP',
};

export const SIDES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};
